import { Form, InputNumber } from 'antd';
import FormField from 'components/FormField';
import { formatNumber } from 'utils/numberFormat';
import { useTranslate } from '@tolgee/react';
import { Alert } from 'views/Aide/Scenario/PolicyForm/TermOfValidityField';
import { FV } from './share';

const minNum = 1;
const maxNum = 1000000;

function CouponNum({ disabled = false }: { disabled?: boolean }) {
  const { t } = useTranslate();

  return (
    <Form.Item required label={t('aide.券码数量')}>
      <Alert>{t('aide.任务保存后不支持修改券码数量')}</Alert>
      <FormField<FV['couponNum']>
        name="couponNum"
        validate={(value) =>
          value ? undefined : t('department.请输入x', { x: t('aide.券码数量') })
        }
      >
        {({ field }) => {
          return (
            <InputNumber
              disabled={disabled}
              {...field}
              min={minNum}
              max={maxNum}
              precision={0}
              style={{ width: '340px' }}
              placeholder={t('aide.请输入x～y的整数', {
                x: formatNumber(minNum, '0,0'),
                y: formatNumber(maxNum, '0,0'),
              })}
            />
          );
        }}
      </FormField>
    </Form.Item>
  );
}

export default CouponNum;
